// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.details {
    flex-shrink: 0;
}

.details > * {
    flex: 1 1 50%;
}

.marginL10 {
    margin-left: 10px;
}

.addParam {
    justify-content: flex-end;
}
`, "",{"version":3,"sources":["webpack://./src/app/settings/datamodel/common/adatapreview.settings.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".details {\n    flex-shrink: 0;\n}\n\n.details > * {\n    flex: 1 1 50%;\n}\n\n.marginL10 {\n    margin-left: 10px;\n}\n\n.addParam {\n    justify-content: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
